<template>
  <b-modal
    class="modal-form-objective-employee text-muted"
    id="modal-form-objective-employee"
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    size="s"
    title="Add Employee Objective"
  >
    <b-form-group
      label="Employee"
    >
      <custom-select
        v-model="objectivePerEmployee"
        placeholder="Select Employee"
        :options="optionsEmployee"
        multiple
      />
    </b-form-group>
    <div>
      <b-button
        class="text-white"
        block
        variant="warning"
        @click="create"
      >
        Add
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    employees: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      objectivePerEmployee: [],
      optionsEmployee: []
    }
  },
  methods: {
    create() {
      this.$emit('create', this.objectivePerEmployee)
      this.objectivePerEmployee = []
      this.$bvModal.hide('modal-form-objective-employee')
    }
  },
  watch: {
    employees: {
      handler() {
        this.optionsEmployee = []
        this.optionsEmployee = this.employees.map(employee =>
          employee.fullName
        )
      },
      immediate: true
    }
  }
}
</script>
